// SPDX-License-Identifier: AGPL-3.0-or-later
// parley: accounts sign in only through auth.ahri.cloud (see web/FORK.md).

import RuntimeConfig from '@app/features/app/state/RuntimeConfig';

/**
 * Whether the signed-in account is an SSO-only account. The backend reports
 * `sso.enforced=true` (Fluxer's own instance flag), and then there is no
 * password, no two-factor authentication (TOTP, passkeys, backup codes), no
 * e-mail change or verification and no phone number: all of that lives at
 * the identity provider. The user settings hide those controls, and sudo
 * checks (which would ask for a password or an MFA code) are skipped; the
 * backend lets SSO accounts through like Fluxer does for accounts without
 * password and MFA.
 */
export function isSsoOnlyAccount(): boolean {
	return RuntimeConfig.sso?.enforced === true;
}
